import { Box, Paper, styled } from "@mui/material";

export const FiltersBar = styled(Paper)`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: flex-end;
  padding: 12px 16px;
  background-color: ${({ theme }) => theme.palette.background.secondary};
  border: 1px solid ${({ theme }) => theme.palette.borderColor.default};
  box-shadow: none;
`;

export const KpiGrid = styled(Box)`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
  margin-block-start: 12px;

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;

export const KpiCard = styled(Paper)`
  padding: 16px;
  background-color: ${({ theme }) => theme.palette.background.default};
  border: 1px solid ${({ theme }) => theme.palette.borderColor.default};
  box-shadow: none;
  display: flex;
  flex-direction: column;
  gap: 6px;

  &.warning {
    border-color: ${({ theme }) => theme.palette.warning.main};
  }
`;

export const KpiValue = styled("span")`
  font-size: 1.75rem;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.text.primary};

  &.warning {
    color: ${({ theme }) => theme.palette.warning.main};
  }
`;

export const KpiLabel = styled("span")`
  font-size: 0.875rem;
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const ChartsRow = styled(Box)`
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 12px;
  margin-block-start: 12px;

  @media (max-width: 1100px) {
    grid-template-columns: 1fr;
  }
`;

export const ChartPanel = styled(Paper)`
  padding: 16px;
  background-color: ${({ theme }) => theme.palette.background.default};
  border: 1px solid ${({ theme }) => theme.palette.borderColor.default};
  box-shadow: none;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-height: 320px;
`;

export const ChartBody = styled(Box)`
  flex: 1;
  min-height: 260px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TablePanel = styled(Paper)`
  padding: 16px;
  margin-block-start: 12px;
  background-color: ${({ theme }) => theme.palette.background.default};
  border: 1px solid ${({ theme }) => theme.palette.borderColor.default};
  box-shadow: none;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const EmptyMessage = styled(Box)`
  width: 100%;
  text-align: center;
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 0.875rem;
`;

export const LoaderWrap = styled(Box)`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 48px 0;
`;
